__turbopack_context__.v({
  "caretIcon": "SectionAccordion-module-scss-module__ynLZqa__caretIcon",
  "header": "SectionAccordion-module-scss-module__ynLZqa__header",
  "icon": "SectionAccordion-module-scss-module__ynLZqa__icon",
  "iconButton": "SectionAccordion-module-scss-module__ynLZqa__iconButton",
  "isClosed": "SectionAccordion-module-scss-module__ynLZqa__isClosed",
  "isOpen": "SectionAccordion-module-scss-module__ynLZqa__isOpen",
  "large": "SectionAccordion-module-scss-module__ynLZqa__large",
  "panel": "SectionAccordion-module-scss-module__ynLZqa__panel",
  "root": "SectionAccordion-module-scss-module__ynLZqa__root",
  "small": "SectionAccordion-module-scss-module__ynLZqa__small",
  "subtitle": "SectionAccordion-module-scss-module__ynLZqa__subtitle",
  "summary": "SectionAccordion-module-scss-module__ynLZqa__summary",
  "summaryDisabled": "SectionAccordion-module-scss-module__ynLZqa__summaryDisabled",
  "summaryInner": "SectionAccordion-module-scss-module__ynLZqa__summaryInner",
  "title": "SectionAccordion-module-scss-module__ynLZqa__title",
});
